// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'
import Icon from 'components/atoms/Icon'

const Wrapper = styled.div`
  margin-left: 50px;

  &::after {
    display: block;
    clear: both;
    content: '';
  }
  ${mediaMax.phone`
    margin-left: 0;
  `};
`
const Container = styled.div`
  display: table;
  margin-left: auto;
  margin-right: 0;
  table-layout: fixed;
`
const StatusWrapper = styled.div`
  display: inline-block;
  padding-right: ${spacing.small_2}px;
  vertical-align: bottom;
`
const Status = styled.span`
  display: block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: right;
  line-height: 1.5;
`
const MessageWrapper = styled.div`
  display: table-cell;
  width: 290px;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
  ${mediaMax.phone`
    width: 264px;
  `};
`
const ThumbnailWrapper = styled.div`
  position: relative;
  display: block;
  padding-top: 66%;
`
const Thumbnail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.url});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`
const MessageContent = styled.div`
  display: inline-block;
  width: 100%;
  max-width: calc(100% - 40px);
  background-color: ${Colors.subBgColor};
  border-radius: 16px;
  border-bottom-right-radius: ${borderRadius}px;
  overflow: hidden;
  font-size: ${fontSize.small_3}px;
`

type PropTypes = {
  time?: string,
  thumbnailUrl: string,
  src: string,
  read: boolean,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <MessageWrapper>
        <StatusWrapper>
          {props.read && (
            <Status>
              {i18n.t('page.dashboard.reservation.alreadyRead')}
              <br />
            </Status>
          )}
          <Status>{props.time}</Status>
        </StatusWrapper>
        <MessageContent>
          <a href={props.thumbnailUrl} target="_blank">
            <ThumbnailWrapper>
              <Thumbnail url={props.src} />
            </ThumbnailWrapper>
          </a>
        </MessageContent>
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/SendImageSelf/index.jsx